import { ExprNode } from '@mode-switch/express';
import { Pipeline } from '../Pipeline';
import { PipelineError } from '../PipelineError';
export var ExprCalls;
(function (ExprCalls) {
    function make(catalog, model, viewName, exprEnv) {
        return (pipeline, node) => {
            switch (node.type) {
                case "CallExpression":
                    return vCall(pipeline, catalog, model, viewName, exprEnv, node);
                default:
                    return pipeline;
            }
        };
    }
    ExprCalls.make = make;
    function vCall(pipeline, catalog, model, viewName, exprEnv, node) {
        const type = Pipeline.DataTypes.get(pipeline, node);
        const role = Pipeline.DataRoles.get(pipeline, node);
        if (type == null) {
            return new PipelineError.InternalError(`Could not resolve data type of node ${node}`);
        }
        const args = new Array();
        for (const parseNode of node.arguments) {
            const argNode = Pipeline.ExprNodes.get(pipeline, parseNode);
            if (argNode == null) {
                return new PipelineError.InternalError(`Could not resolve argument ${argNode} of ${node.callee}`);
            }
            args.push(argNode);
        }
        const callName = ExprNode.CallName.make(node.callee);
        const callArgs = catalog.getCallArgs(model, viewName, callName, args);
        const callErrors = catalog.validateExprCall(node, callName, callArgs, type, role);
        if (callErrors.length > 0) {
            return new PipelineError.InvalidExprCall(callName.name, callErrors);
        }
        const call = catalog.getExprCall(exprEnv, callName, callArgs, type, role);
        if (call != null) {
            return Pipeline.ExprCalls.set(Pipeline.CallArgs.set(pipeline, node, callArgs), node, call);
        }
        return new PipelineError.InternalError(`Could not resolve function ${node.callee}`);
    }
})(ExprCalls || (ExprCalls = {}));
